import React from "react";
import CreateContent from "./create-content.jsx";
import UpdateContent from "./update-content.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const actionMap = {
    view: "Visualização",
    create: "Cadastro",
    update: "Alteração",
    delete: "Exclusão"
};

const AuditContent = ({element, animals, garrisonLeader}) => {
    const navigate = navigateHook();

    return (
        <table className="table report-table mb-4 audit-content-table">

            <thead style={{background: "#F2F2F2"}}>
                <tr className="text-left">
                    <th style={{width: "15%"}}>ID</th>
                    <th style={{width: "15%"}}>Ação</th>
                    <th style={{width: "25%"}}>Agente</th>
                    <th style={{width: "55%"}}>Data/hora</th>
                </tr>
            </thead>

            <tbody>

            <tr className="text-left">
                <td><a onClick={() => navigate(`/despacho/garrison/form/${element?.entityid}`, true)} rel="noreferrer" className="report-link">{element?.entityid}</a></td>
                <td>{actionMap[element?.action] ?? element?.action}</td>
                <td>{element?.owner}</td>
                <td>{element?.created}</td>
            </tr>

            {element?.action !== "view" && (
                element?.action === "create" ? (
                    <CreateContent element={element} animals={animals} garrisonLeader={garrisonLeader}/>
                ) : (
                    <UpdateContent element={element} animals={animals}/>
                )
            )}

            </tbody>

        </table>
    );
};

export default AuditContent;